import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import HomeWithAccount from './Home';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import store from './store/store';
import { SnackbarProvider } from 'notistack';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

// import register from './registerServiceWorker';
// register();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <StrictMode>
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <SnackbarProvider maxSnack={5}>
                    <BrowserRouter basename={baseUrl}>
                        <HomeWithAccount />
                    </BrowserRouter>
                </SnackbarProvider>
            </Provider>
        </I18nextProvider>
    </StrictMode>,
    rootElement
);
